import React from 'react';
import styled, { useTheme } from 'styled-components';
import Icon from 'components/Icon';
import { usePrintCashReport } from 'hooks/usePrintCashReport';

const PrintIcon = styled.div`
  cursor: pointer;
  margin-right: 15px;

  /* Zoom on scroll */
  transform: scale(1);
  transition: transform 0.3s ease;
  &:hover {
    transform: ${(props) => (props.disabled ? 'none' : 'scale(1.1)')};
  }

  /* Handle disabled prop */
`;

const PrintCashDrawerReport = ({
  isConnected,
  cashDrawerReport,
  setIsPrinting,
}) => {
  const { printReport } = usePrintCashReport();
  const theme = useTheme();

  const onPrint = () => {
    printReport({ cashDrawerReport, setIsPrinting: setIsPrinting });
  };

  return (
    <PrintIcon
      onClick={isConnected ? onPrint : undefined}
      disabled={!isConnected}
    >
      <Icon
        icon="Print-Icon"
        size={45}
        color={!isConnected ? '#ccc' : theme.colors.primary}
      />
    </PrintIcon>
  );
};

export default PrintCashDrawerReport;
